<template>
    <span class="sprite-icon" :class="icon"></span>
</template>

<script>
export default {
  props: {
    icon: {},
  },
  data: () => ({
        
  }),
}
</script>

<style lang="scss" scoped>
@import "~@/styles/sprite-icon.scss";
</style>